"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function HBLogoSvg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 27, height: 14, viewBox: "0 0 27 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("g", { id: "HB logo" },
            react_1.default.createElement("path", { id: "Logo", fillRule: "evenodd", clipRule: "evenodd", d: "M23.03 5.92073C23.9336 5.36836 24.4707 4.36673 24.4707 3.304C24.4707 1.41655 22.8391 0 19.9576 0H11.0931V6.118C7.83364 5.964 5.42564 5.33145 3.93782 4.50418V0.00127273H0V14H3.93782V7.85018C6.32291 8.71818 8.64691 9.15982 11.0931 9.20818V14H19.6687C24.0075 14 26.0044 12.152 26.0044 9.55691C26.0044 7.76746 24.7762 6.47054 23.0287 5.922L23.03 5.92073ZM15.0309 2.75418L19.1519 2.74782C20.3699 2.74782 20.7645 3.19836 20.7645 3.72782C20.7645 4.73073 18.4074 5.71073 15.0309 5.97545V2.75418ZM21.358 10.7761C21.7373 10.5546 22.0059 10.295 22.1344 10.0061C22.4819 9.22592 21.9346 8.26883 21.0615 8.0881C20.6275 7.99901 19.9237 7.99519 18.95 8.23701C18.7477 8.28742 18.5516 8.33784 18.3564 8.38798C17.4137 8.63026 16.4953 8.86626 15.0275 9.06556V11.247H19.3509C20.0344 11.2177 20.7599 11.1248 21.358 10.7761Z", fill: "white" })));
}
function HBLogo(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(HBLogoSvg, Object.assign({}, svgProps)));
}
exports.default = HBLogo;
//# sourceMappingURL=HBLogo.js.map